import { render, staticRenderFns } from "./Derived.vue?vue&type=template&id=1cb9b76e&scoped=true"
import script from "./Derived.vue?vue&type=script&lang=js"
export * from "./Derived.vue?vue&type=script&lang=js"
import style0 from "./Derived.vue?vue&type=style&index=0&id=1cb9b76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9b76e",
  null
  
)

export default component.exports